import React from "react";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import ReactDropdown from "react-dropdown";
import { ChoVayCombo } from "constants/choVayConst";

class ChonMaHopDong extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: "",
      dataSearch: {
        pageIndex: 1,
        pageSize: 20,
        ThoiGian: "",
      },
    };
  }
  onChangeData = (field, event) => {
    let state = this.state;
    state[field] = event.target.value;
    this.setState(state);
  };

  renderTableRows() {
    let List = [{ status: 0 }, { status: 1 }, { status: 2 }];
    return List.map((item, index) => (
      <tr>
        <td>1</td>

        <td>
          <a href={() => false} className="blue">
            CV_20180806_0001
          </a>
        </td>

        <td className="text-left">
          <a href={() => false} className="blue">
            Nguyễn Văn A
          </a>
          <br />
          (ĐT: 0912.536.085)
        </td>

        <td>
          20/9/2018
          <br />
          10/8/2019
        </td>

        <td className="red text-right">
          6,000,000
          <br />
          <span className="font-lai">(Lãi suất: 2k/1triệu)</span>
        </td>

        <td className="red text-right">5,400,000</td>
        <td className="red text-right">6,000,000</td>
        <td className="text-left">
          <b>29</b> ngày
          {item.status === 0 && (
            <PopoversBootrap
              contentText={
                <div>
                  {" "}
                  <b>Gia hạn</b>
                  <br />- tại sao lại như thế
                  <br />
                  <b>Ghi chú</b>
                  <br />- Tại sao lại như thế
                </div>
              }
              trigger={["hover", "focus"]}
              placement={"top"}
            >
              <sup className="red">Gia hạn + Ghi chú</sup>
            </PopoversBootrap>
          )}
          {item.status === 1 && (
            <PopoversBootrap
              contentText={
                <div>
                  {" "}
                  <b>Gia hạn</b>
                  <br />- tại sao lại như thế
                </div>
              }
              trigger={["hover", "focus"]}
              placement={"top"}
            >
              <sup className="red">Gia hạn</sup>
            </PopoversBootrap>
          )}
          {item.status === 2 && (
            <PopoversBootrap
              contentText={
                <div>
                  {" "}
                  <b>Ghi chú</b>
                  <br />- tại sao lại như thế
                </div>
              }
              trigger={["hover", "focus"]}
              placement={"top"}
            >
              <sup className="red">Ghi chú</sup>
            </PopoversBootrap>
          )}
        </td>
        <td>
          {item.status === 0 && <span className="canh-bao-red">Nợ xấu</span>}
          {item.status === 1 && <span className="dang-vay">Bình thường</span>}
          {item.status === 2 && <span className="canh-bao-no">Nợ rủi ro</span>}
        </td>
      </tr>
    ));
  }
  render() {
    let props = this.props;
    let { dataSearch } = this.state;
    var TotalQuantity = 15;
    return (
      <Modal
        {...props}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-clipboard-multiple"></i>
            </span>{" "}
            Chọn mã hợp đồng
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="card-content collapse show">
            <div className="">
              <div className="repeater-default">
                <div data-repeater-list="car">
                  <div data-repeater-item className="col-sm-12">
                    <form className="form row bg-search-form">
                      <div className="form-group mb-1 col-sm-12 col-md-9">
                        <div className="row">
                          <div className="col-md-3 ml-2 input-sm pad-0 pad-col">
                            <input
                              type="text"
                              className="form-control input-sm"
                              placeholder="Tên, sđt khách hàng"
                            />
                          </div>

                          <div className="col-md-2 input-sm pad-0 pad-col">
                            <input
                              className="form-control input-sm datepicker-default "
                              type="text"
                              placeholder="Đến ngày"
                            />
                          </div>

                          <div className="col-md-2 input-sm pad-0 pad-col">
                            <ReactDropdown
                              options={ChoVayCombo.KieuVayCombo}
                              placeholder="Select an option"
                              controlClassName="form-control input-sm"
                              arrowClassName=""
                            />
                          </div>

                          <div className="text-left col-md-2 pad-search mad-col button-search-1">
                            <button type="submit" className="btn btn-info-new">
                              <i className="la la-search"></i>
                            </button>
                            <a
                              href={() => false}
                              className="card-link blue darken-2 t-text"
                            >
                              Nâng cao
                            </a>
                          </div>
                        </div>
                      </div>

                      <div className="form-group mb-1 col-sm-6 col-md-3  text-right left-search">
                        <span className="btn-npt left-m5">
                          <button type="button" className="btn btn-info  ">
                            Nợ phải thu ngày mai
                          </button>
                        </span>
                        <span className=" print-dsnpt "></span>
                        <span className=" print-dsnpt ">
                          <a className="btn btn-info" href={() => false}>
                            <PopoversBootrap
                              contentText="In danh sách"
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <i className="la la-print"></i>
                            </PopoversBootrap>
                          </a>
                          <a className="btn btn-info" href={() => false}>
                            <PopoversBootrap
                              contentText="Xuât danh sách"
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <i className="la la-level-up"></i>
                            </PopoversBootrap>
                          </a>
                        </span>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="Left-table1 mt-ma-hd">
                <div className="table-responsive table-2">
                  <table className="table table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>
                          STT
                          <br /> <span className="red">[ 17 ]</span>
                        </th>

                        <th>Mã hợp đồng</th>
                        <th className="text-left">Tên khách hàng</th>

                        <th>Thời gian vay</th>
                        <th className="text-right">
                          Số tiền vay
                          <br />{" "}
                          <span className="red">
                            <i className="la la-dollar text-b"></i>= 25.000.000
                          </span>
                        </th>
                        <th className="text-right">
                          Số tiền đã trả
                          <br />{" "}
                          <span className="red">
                            <i className="la la-dollar text-b"></i>= 25.000.000
                          </span>
                        </th>
                        <th className="text-right">
                          Số tiền thanh toán
                          <br />{" "}
                          <span className="red">
                            <i className="la la-dollar text-b"></i>= 25.000.000
                          </span>
                        </th>
                        <th className="w-15 text-left">Quá hạn</th>
                        <th className="">Tình trạng</th>
                      </tr>
                    </thead>
                    <tbody>{this.renderTableRows()}</tbody>
                  </table>
                </div>
                <div
                  className={
                    "paniation-new paniation-new1 d-flex justify-content-center mt-1" +
                    (TotalQuantity === 0 ? "hidden" : "")
                  }
                >
                  <nav aria-label="Page navigation">
                    <Pagination
                      activePage={dataSearch.pageIndex}
                      itemsCountPerPage={dataSearch.pageSize}
                      totalItemsCount={TotalQuantity}
                      pageRangeDisplayed={5}
                      onChange={this.handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                      activeClass="active"
                    />
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          <a className="btn btn-new-main btn-checknew" href={() => false}>
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>{" "}
            Chọn
          </a>

          <a
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={props.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ChonMaHopDong;
